import { Box, FormControl, InputLabel, TextFieldProps } from '@material-ui/core';
import React, { ReactNode, useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import { useStyles } from './SingleFieldContactInput.styles';

type Props = {
  country?: string;
  labelTxt?: ReactNode;
  showLabel?: boolean;
  inputValue: string;
  customPlaceholder?: string;
  onChange?: (value: string, data: any, event: React.ChangeEvent<HTMLInputElement>, formattedValue: string) => void;
  errorMessage?: string;
  fullWidth?: boolean;
  masks?: object;
} & Omit<TextFieldProps, 'onChange'>;
const SingleFieldContactInput: React.FC<Props> = ({
  labelTxt = 'Phone Number',
  country,
  showLabel = false,
  inputValue,
  customPlaceholder = 'Type here...',
  onChange,
  errorMessage,
  fullWidth,
  masks,
  ...props
}) => {
  const classes = useStyles();

  const [localCountry, setLocalCountry] = useState(country);
  const [localInputValue, setLocalInputValue] = useState(inputValue);

  useEffect(() => {
    setLocalCountry(country);
    setLocalInputValue(inputValue);
  }, [country, inputValue]);

  return (
    <FormControl fullWidth={fullWidth} style={{ marginTop: 0, width: '100%' }}>
      {showLabel && (
        <InputLabel id="lblContactInput" shrink>
          <span>{labelTxt}</span>
        </InputLabel>
      )}
      <div className={classes.inputContainer}>
        <PhoneInput
          country={localCountry || 'au'}
          countryCodeEditable={false}
          masks={{
            au: '(...) ... ...',
            us: '(...) ... ....',
          }}
          autoFormat={true}
          preferredCountries={['us', 'au', 'nz', 'ca', 'gb']}
          placeholder={customPlaceholder}
          disabled={props.disabled}
          inputClass={classes.contactInput_class}
          containerClass={classes.contactContainer_class}
          buttonClass={classes.contactButton_class}
          onChange={onChange}
          value={localInputValue}
          disableCountryGuess
        />
      </div>
      {errorMessage && <span className={classes.spanError}>{errorMessage}</span>}
    </FormControl>
  );
};

export default SingleFieldContactInput;
